import { queryClient } from "@/queryClient"
import api from "@/services/api"
import { BASE_ORDERS_QUERY_KEY } from "../queryKeys"

export const acceptSignature = async (
  transactionId: string
) => {
  await api.post(
    `/transactions/${transactionId}/accept-signature/`
  )

  queryClient.invalidateQueries({
    queryKey: [BASE_ORDERS_QUERY_KEY],
  })
}
